<!-- page starts-->
    <section class="page-wrapper">
      <div class="cart-top-section">
             <div class="container">
                  <div class="cart-top-detail">
                        <div class="red-titel">Checkout</div>
                  </div>
             </div>
      </div>
      <div class="checkout-center-section cf">
         <div class="container">
          <div class="checkout-center-detail cf">
            <div class="checkout-center-detail-left">
                              <div class="cart-center-detail-top cf">
                                    <div class="cart-center-top cf">
                                          <div class="cart-center-top-left">
                                                <div class="cart-center-top-left-image">
                                                      <img src="assets/images/Bitmap.png">
                                                </div>
                                                <div class="cart-center-top-left-vs">
                                                      <div class="cart-center-top-left-vs-inner">
                                                            <h3>VS</h3>
                                                      </div>
                                                </div>
                                                <div class="cart-center-top-left-right-image">
                                                      <img src="assets/images/Bitmap-two.png">
                                                </div>
                                          </div>
                                          <div class="cart-center-top-center">
                                                <p>Ashton United V South Shields</p>
                                                <h3>Saturday, 3 November 2020 15:00</h3>
                                          </div>
                                    </div>
                                    <div class="cart-center-bottom cf">
                                          <div class="cart-center-bottom-general">
                                                <h3>General Admission </h3>
                                                <div class="checkout-center-detail-right-general-admission-detail cf">
                                                      <div class="checkout-center-detail-right-general-admission-name">
                                                            <h3>Senior (Over 65) #112</h3>
                                                            <p>Assigned to: John Smith <br><a href="">johnsmith@gmail.com </a>| ASH0000843</p>
                                                      </div>
                                                      <div class="checkout-center-detail-right-general-admission-price">
                                                            <p>£20.00</p>
                                                      </div>
                                                      <div class="checkout-center-detail-right-away-fans-btn">
                                                            <p><a href="#">Edit Details</a></p>
                                                      </div>
                                                </div>
                                          </div>
                                          <div class="cart-center-bottom-away">
                                                <h3>Away Fans </h3>
                                                <div class="checkout-center-detail-right-general-admission-detail cf">
                                                      <div class="checkout-center-detail-right-general-admission-name">
                                                            <h3>Senior (Over 65) #112</h3>
                                                            <p>Assigned to: John Smith <br><a href="">johnsmith@gmail.com </a>| ASH0000843</p>
                                                            <h3>Senior (Over 65) #112</h3>
                                                            <p>Assigned to: John Smith <br><a href="">johnsmith@gmail.com </a>| ASH0000843</p>
                                                      </div>
                                                      <div class="checkout-center-detail-right-general-admission-price">
                                                            <p>£20.00</p>
                                                            <p>£20.00</p>
                                                      </div>
                                                      <div class="checkout-center-detail-right-away-fans-btn">
                                                            <p><a href="#">Edit Details</a></p>
                                                            <p><a href="#">Edit Details</a></p>                  
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                              <div class="cart-center-detail-top cf">
                                    <div class="cart-center-top cf">
                                          <div class="cart-center-top-left">
                                                <div class="cart-center-top-left-image">
                                                      <img src="assets/images/Bitmap.png">
                                                </div>
                                                <div class="cart-center-top-left-vs">
                                                      <div class="cart-center-top-left-vs-inner">
                                                            <h3>VS</h3>
                                                      </div>
                                                </div>
                                                <div class="cart-center-top-left-right-image">
                                                      <img src="assets/images/Bitmap-two.png">
                                                </div>
                                          </div>
                                          <div class="cart-center-top-center">
                                                <p>Ashton United V South Shields</p>
                                                <h3>Saturday, 3 November 2020 15:00</h3>
                                          </div>
                                    </div>
                                    <div class="cart-center-bottom cf">
                                          <div class="cart-center-bottom-general">
                                                <h3>General Admission </h3>
                                                <div class="checkout-center-detail-right-general-admission-detail cf">
                                                      <div class="checkout-center-detail-right-general-admission-name">
                                                            <h3>Senior (Over 65) #112</h3>
                                                            <p>Assigned to: John Smith <br><a href="">johnsmith@gmail.com </a>| ASH0000843</p>
                                                      </div>
                                                      <div class="checkout-center-detail-right-general-admission-price">
                                                            <p>£20.00</p>
                                                      </div>
                                                      <div class="checkout-center-detail-right-away-fans-btn">
                                                            <p><a href="#" >Edit Details</a></p>
                                                      </div>
                                                </div>
                                          </div>
                                          
                                    </div>
                              </div>
                        </div>
            <div class="checkout-center-detail-right">
                <div class="checkout-center-detail-right-inner">
                    <h2>Bookings Summary</h2>
                    <div class="checkout-center-detail-right-general-admission">    
                      <div class="checkout-center-detail-code">
                        <div class="checkout-center-detail-code-voucher">
                          <a href="#">Apply voucher</a>
                        </div>
                        <div class="checkout-center-detail-code-box">
                          <a href="#">RR99EDU CODE</a>
                        </div>
                      </div>
                      <div class="checkout-center-detail-payment">
                        <div class="checkout-center-detail-payment-total">
                          <div class="checkout-payment-total">
                            <div class="checkout-payment-total-text">Total</div>
                            <div class="checkout-payment-total-price">£20.00</div>
                          </div>
                          <div class="checkout-payment-discount">
                            <div class="checkout-payment-discount-text">Order Discount</div>
                            <div class="checkout-payment-discount-price">£20.00</div>
                          </div>
                        </div>
                        <div class="checkout-payment-payable">
                          <div class="checkout-payment-payable-text">Payable Amount</div>
                          <div class="checkout-payment-payable-price">£20.00</div>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="checkout-center-detail-left">
                          <div class="checkout-center-detail-address">
                            <div class="checkout-center-detail-address-titel">
                              <h2>Add Address</h2>
                            </div>
                            <div class="checkout-center-detail-address-box cf">
                                <div class="checkout-address-box half">
                                  <input type="text" name="" placeholder="First Name" class="input-style"> 
                                </div>  
                                <div class="checkout-address-box half">
                                  <input type="text" name="" placeholder="last Name" class="input-style"> 
                                </div>  
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="company" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="Address1" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="Address2" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="City" class="input-style"> 
                                </div>
                                <div class="checkout-address-box half">
                                  <input type="text" name="" placeholder="Country" class="input-style"> 
                                </div>
                                <div class="checkout-address-box half">
                                  <input type="text" name="" placeholder="Post Code" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="Phone" class="input-style"> 
                                </div>
                                <div class="show-your-support-right-content-checkbox">
                                  <label class="container-check">Save this information for next time
                                    <input type="checkbox" checked="checked">
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                            </div>
                            <div class="checkout-center-detail-address-content-box" style="">
                              <div class="checkout-center-detail-address-content">
                                <h3>Tom Curran</h3>
                                <p>Hurst Cross Stadium,surray Street,Ashton-under-lyne,Greater Manchester,OL68DY</p>
                              </div>
                              <div class="checkout-center-detail-address-btn">
                                <a href="#">Change Address or Add Address</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="checkout-payment-payable-btn">
                          <a href="#">Confirm & Pay</a>
                        </div>
            </div>
          </div>
          
         </div>
      </div>
    </section><!-- page ends-->
